"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _selectors = require("../selectors");
const withOriginServerHeader = procedureObject => ({
  ...procedureObject,
  call: _ref => {
    let {
      fetchClient,
      getState,
      args: {
        headers,
        ...args
      } = {},
      ...opts
    } = _ref;
    const state = getState();
    const origin = (0, _selectors.getOrigin)(state);
    const updatedHeaders = {
      ...headers,
      ...(!global.BROWSER ? {
        origin
      } : {})
    };
    return procedureObject.call({
      fetchClient,
      getState,
      args: {
        ...(Object.keys(updatedHeaders).length > 0 ? {
          headers: updatedHeaders
        } : {}),
        ...args
      },
      ...opts
    });
  }
});
var _default = withOriginServerHeader;
exports.default = _default;